var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bodyPage"},[_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"预售订单"}},[_c('List')],1),_c('el-tab-pane',{attrs:{"label":"选购记录"}},[_c('Log')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }